export default () =>
  import(
    /* webpackChunkName: 'coffee/activities/half-coupon' */ './HalfCoupon'
  );
